var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7651 15.6834L3.65164 8.59103C3.5672 8.5066 3.50726 8.41513 3.47179 8.31662C3.43633 8.21812 3.41888 8.11258 3.41945 8C3.41945 7.88742 3.4369 7.78188 3.47179 7.68338C3.50669 7.58487 3.56664 7.4934 3.65164 7.40897L10.7651 0.295514C10.9621 0.0985048 11.2084 0 11.5039 0C11.7994 0 12.0527 0.105541 12.2638 0.316623C12.4749 0.527704 12.5804 0.773967 12.5804 1.05541C12.5804 1.33685 12.4749 1.58311 12.2638 1.7942L6.05797 8L12.2638 14.2058C12.4608 14.4028 12.5593 14.6457 12.5593 14.9345C12.5593 15.2232 12.4537 15.4729 12.2427 15.6834C12.0316 15.8945 11.7853 16 11.5039 16C11.2224 16 10.9762 15.8945 10.7651 15.6834Z",
    fill: "#4B33A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.1910cfd3dbeb2d1fb88f1700aa52ddcd.svg";
export { ForwardRef as ReactComponent };